// exported separately as imported by worker
export const promotedSelectors = ["fv", "chgfv"] as const;

export default [
  { name: "FV OTHER", subItems: ["chgfv-mid", "fv-mid"] },
  {
    name: "QUOTES",
    subItems: [
      "ask",
      "asksize",
      "bid",
      "bidsize",
      "chg%exch",
      "chgexch",
      "chgtick",
      "high",
      "last",
      "lastsize",
      "lasttime",
      "low",
      "wav",
    ],
  },
  {
    name: "VOLUMES & OI",
    subItems: ["oi", "oichg", "oidate", "volm", "volmprior"],
  },
  { name: "MARKERS", subItems: ["mm-lon", "mm-nyc", "mm-sin"] },
  {
    name: "EOD",
    subItems: ["close", "settle-chg", "settle-prior", "settle-today"],
  },
  {
    name: "DATES",
    subItems: ["expiry", "first-effective", "second-effective", "pricing-days", "total-pricing-days"],
  },
];
